var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99992 0.333344C4.93717 0.333344 0.833252 4.43726 0.833252 9.50001C0.833252 14.5628 4.93717 18.6667 9.99992 18.6667C15.0627 18.6667 19.1666 14.5628 19.1666 9.50001C19.1666 4.43726 15.0627 0.333344 9.99992 0.333344ZM13.2358 9.0692C13.1019 9.20304 12.9259 9.27084 12.7499 9.27084C12.5739 9.27084 12.3979 9.20395 12.2641 9.0692L10.6874 7.49256V13.1667C10.6874 13.5462 10.3794 13.8542 9.99992 13.8542C9.62042 13.8542 9.31242 13.5462 9.31242 13.1667V7.49346L7.73578 9.0701C7.4672 9.33868 7.03175 9.33868 6.76316 9.0701C6.49458 8.80152 6.49458 8.36607 6.76316 8.09748L9.51316 5.34748C9.57641 5.28423 9.6524 5.23394 9.73673 5.19911C9.90448 5.12944 10.0942 5.12944 10.262 5.19911C10.3463 5.23394 10.4225 5.28423 10.4858 5.34748L13.2358 8.09748C13.5044 8.36607 13.5044 8.80062 13.2358 9.0692Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.062c4dc76627488000c530f3a420ec6b.svg";
export { ForwardRef as ReactComponent };